import LoadingErrorPanel from '@/components/common/LoadingErrorPanel';
import LoadingMessage from '@/components/common/LoadingMessage';
import { VStack } from '@/components/sgBootstrapReactWrapper';
import { useGetAlternativeOperationDetailsQuery, useGetBondOperationDetailsQuery, useGetCashOperationDetailsQuery, useGetEquityOperationDetailsQuery, useGetFxForwardOperationDetailsQuery, useGetOtherOperationDetailsQuery } from '@/store/api/root.api';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { positionDisplayedInDrawer, setPositionDisplayedInDrawer, type PositionId } from '@/store/position/slice';
import { isDefined, isNotDefined } from '@/utils/assertions';
import { skipToken } from '@reduxjs/toolkit/query';
import { PositionDetailsDrawerBody } from './PositionDetailsDrawerBody';
import { PositionDetailsDrawerHeader } from './PositionDetailsDrawerHeader';
import { getTemplate, mapAssetClassToPositionTypeName, type PositionType, type PositionTypeName, type Template } from './template';
import { canSeeRestrictedData } from '@/store/user/userSlice';

const PositionDetailsDrawer = () => {
  const dispatch = useAppDispatch()
  const isFim = !useAppSelector(canSeeRestrictedData)
  const request = useAppSelector(positionDisplayedInDrawer)
  const { data: position, isLoading, isFetching, isError, error } = getPosition(request);
  const isDrawerReady = !isLoading && !isFetching;
  const handleClose = () => dispatch(setPositionDisplayedInDrawer(null))
  const templateName = getTemplateName(position)
  const template: Template = isDefined(templateName) ? getTemplate(templateName, isFim) : { title: '', headerFields: [], tabs: [], type: 'MISCELLANEOUS' }

  return isDefined(request) && <div>
    <div data-e2e="operation-details-drawer"
      className="offcanvas offcanvas-end show px-8px"
      style={{ width: 'auto', minWidth: '720px' }} >
      <VStack className="h-100">
        {
          isDrawerReady && isDefined(position) && <>
            <PositionDetailsDrawerHeader position={position} onClose={handleClose} template={template} />
            <PositionDetailsDrawerBody position={position} template={template} />
          </>
        }
        {!isDrawerReady && <LoadingMessage />}
        {isError && <LoadingErrorPanel error={error} />}
      </VStack>
    </div>
    <div className="offcanvas-backdrop fade show" onClick={handleClose} />
  </div>
}
export default PositionDetailsDrawer;

const getTemplateName = (position: PositionType | undefined): PositionTypeName | undefined => {
  if (isNotDefined(position)) return undefined
  return mapAssetClassToPositionTypeName(position.assetClass)
}

const getPosition = (request: PositionId | null) => {
  const posType: PositionTypeName | undefined = request?.positionType
  const param = request ? { ...request } : skipToken
  switch (posType) {
    case 'ALTERNATIVE': return useGetAlternativeOperationDetailsQuery(param)
    case 'BOND': return useGetBondOperationDetailsQuery(param)
    case 'CASH': return useGetCashOperationDetailsQuery(param)
    case 'EQUITY': return useGetEquityOperationDetailsQuery(param)
    case 'FORWARD': return useGetFxForwardOperationDetailsQuery(param)
    default: return useGetOtherOperationDetailsQuery(param)
  }
}